import styled from 'styled-components';
import theme from '../../theme';

export const LoginContainer = styled.div`
	display: inline-block;
	margin: 0 auto;
	border: 1px solid lightgrey;
	margin-top: 20px;
	padding: 10px 40px;
	box-shadow: 1px 1px 2px lightgrey;
	padding-bottom: 50px;
`;

export const Image = styled.img`
	width: 100px;
	transform: TranslateX(8%);
`;

export const Button = styled.button`
	border: 1px solid ${theme.pink.dark};
	background-color: ${theme.pink.dark};
	color: white;
	padding: 5px 20px;
	box-shadow: 1px 1px 2px lightgrey;
	font-size: 1.4em;
	transform: TranslateY(0);
	transition: transform 0.2s;
	cursor: pointer;

	&:hover {
		transform: TranslateY(-3px);
	}
`;

export const Signup = styled.span`
	font-weight: 100;
	
	
	& a {
		text-decoration: none;
		color: ${theme.pink.dark};
	}
`;